import {Box, Chip, TextField, Typography} from "@mui/material";
import React, {useRef, useState} from "react";

export default function UrlWithParams(params) {
    const {label, name, register, errors, watch, setValue, compact = false, urlType = 'landing'} = params;
    const [cursor, setCursor] = useState("");
    const inputRef = useRef(null);

    const handleChipClick = (item) => {
        if (compact) {
            const input = inputRef.current;
            const url = watch(name) || '';
            const start = input?.selectionStart ?? url.length;
            const end = input?.selectionEnd ?? start;
            setValue(name, url.slice(0, start) + item + url.slice(end), {shouldDirty: true, shouldValidate: true});
            input?.focus();
            input?.setSelectionRange(start + item.length, start + item.length);
            return;
        }
        let e = cursor;
        if (cursor === "" || cursor === undefined) {
            setValue(name, watch(name) + item);
            return false;
        }

        let s = {start: 0, end: 0};
        if (typeof e.target.selectionStart == "number" && typeof e.target.selectionEnd == "number") {
            s.start = e.target.selectionStart;
            s.end = e.target.selectionEnd;
        }

        if (s.start !== s.end) {
            // Replace selected text range.
            let before = e.target.value.slice(0, s.start);
            let after = e.target.value.slice(s.end);
            e.target.value = before + item + after;
            e.target.selectionEnd = before?.length + item?.length;
        } else {
            // Set new item where cursor is.
            let cursorPosition = e.target.selectionStart;
            let textBeforeCursorPosition = e.target.value.substring(0, cursorPosition);
            let textAfterCursorPosition = e.target.value.substring(cursorPosition, e.target.value.length);
            e.target.value = textBeforeCursorPosition + item + textAfterCursorPosition;
            e.target.selectionEnd = textBeforeCursorPosition?.length + item?.length;
        }

        setValue(name, e.target.value);
    };

    const urlChip = (placeholder) => {
        let url = watch(name);
        return (
            <Chip label={placeholder} color="primary" size="small" variant={compact ? 'outlined' : 'filled'}
                  sx={compact ? {fontSize: 11, fontFamily: 'monospace', maxWidth: '100%'} : {fontSize: 12}}
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => handleChipClick(placeholder)}
                  disabled={!!url?.includes(placeholder)}
            />
        );
    };

    const handleOnClick = (e) => {
        setCursor(e);
    };

    return (
        <Box sx={compact ? {display: 'grid', gap: 1.5, minWidth: 0} : {pt: 1, paddingBottom: "12px"}}>
            <TextField
                error={!!errors?.url}
                variant="outlined"
                margin="dense"
                {...register(name, {
                    required: compact ? `Enter a ${urlType} URL.` : true,
                    pattern: /^https?:\/\/(www\.)?[-a-zA-Z\d@:%._+~#=]{1,512}\.[a-zA-Z\d()]{1,20}\b([-a-zA-Z\d()@:%_+.~#?&/=]*)/
                })}
                name={name}
                inputRef={compact ? inputRef : undefined}
                helperText={compact && errors[name] ? errors[name].message || `Enter a valid HTTP or HTTPS ${urlType} URL.` : undefined}
                size="small"
                label={label}
                placeholder="e.g. https://example.com"
                type="text"
                fullWidth
                onClick={handleOnClick}
                slotProps={{
                    inputLabel: {
                        shrink: true
                    }
                }}
                sx={compact ? undefined : {marginTop: "18px", marginBottom: "20px"}}
            />
            {compact && <Typography sx={{fontSize: 12, color: 'text.secondary'}}>Click a token to insert it at the cursor.</Typography>}
            <Box sx={compact ? {display: 'flex', flexWrap: 'wrap', gap: 0.75, minWidth: 0} : undefined}>
            {urlChip("{clickId}")}
            {urlChip("{externalId}")}
            {urlChip("{campaignId}")}
            {urlChip("{campaignName}")}
            {urlChip("{trafficSourceId}")}
            {urlChip("{trafficSourceName}")}
            {urlChip("{landingId}")}
            {urlChip("{landingName}")}
            {urlChip("{offerId}")}
            {urlChip("{offerName}")}
            {urlChip("{deviceType}")}
            {urlChip("{deviceVendor}")}
            {urlChip("{deviceModel}")}
            {urlChip("{browser}")}
            {urlChip("{browserVersion}")}
            {urlChip("{os}")}
            {urlChip("{osVersion}")}
            {urlChip("{ip}")}
            {urlChip("{isp}")}
            {urlChip("{country}")}
            {urlChip("{state}")}
            {urlChip("{city}")}
            {urlChip("{lang}")}
            {urlChip("{userAgent}")}
            {urlChip("{trackingDomain}")}
            {urlChip("{referrerDomain}")}
            {urlChip("{custom1}")}
            {urlChip("{custom2}")}
            {urlChip("{custom3}")}
            {urlChip("{custom4}")}
            {urlChip("{custom5}")}
            {urlChip("{custom6}")}
            {urlChip("{custom7}")}
            {urlChip("{custom8}")}
            {urlChip("{custom9}")}
            {urlChip("{custom10}")}
            {urlChip("{custom1Hash}")}
            {urlChip("{custom2Hash}")}
            {urlChip("{custom3Hash}")}
            {urlChip("{custom4Hash}")}
            {urlChip("{custom5Hash}")}
            {urlChip("{custom6Hash}")}
            {urlChip("{custom7Hash}")}
            {urlChip("{custom8Hash}")}
            {urlChip("{custom9Hash}")}
            {urlChip("{custom10Hash}")}
            {urlChip("{landingKey}")}
            </Box>
        </Box>
    );
}
